export const REPORT_TYPE = {
  AUDIT: 'AUDIT',
  HISTORY: 'HISTORY',
};

export const buildBenefitReportHeaders = (reportType, isCNG) => {
  let headers = [
    'Status', 'Agency Email', 'Date Entered', 'Audit Date', 'Agency Name',
    'New/Corrected', 'Last Name', 'First Name', 'Account Number',
    'Service Address', 'Town', 'State', 'Zip', 'Fund', 'Grant'
  ];

  // HISTORY includes Prior Grant Amount
  if (reportType === REPORT_TYPE.HISTORY) {
    headers.push('Prior Grant Amount');
  }

  if (isCNG) {
    headers.push('FPL', 'SMI', 'AMI', 'Energy Discount');
    // HISTORY includes Prior Energy Discount
    if (reportType === REPORT_TYPE.HISTORY) {
      headers.push('Prior Energy Discount');
    }
    headers.push('Arrearage Mgmt', 'Weatherization Program Interest');
  }

  headers.push('Additional Information', 'Reason for Change');

  // HISTORY includes Automatically Uploaded
  if (reportType === REPORT_TYPE.HISTORY) {
    headers.push('Automatically Uploaded');
  }

  return headers;
};
